import React, { useState } from 'react';
import styled from 'styled-components';
import Value from './Value';
import mediaQueries from './mediaQueries';
import { Button } from '@blockstack/ui';
import { Route, Link, useHistory } from 'react-router-dom';

import { CSSTransition } from 'react-transition-group';
import VisibilitySensor from 'react-visibility-sensor';
import Stat from './Stat';
import Modal from './Modal';
import FAQ from './FAQ';
import Stacking from './Stacking';
type Props = {
    value: string;
    totalStxSupply: string;
    stackingThreshold: string;
    nrRewardsAddresses: string;
    nrUserRewardAddresses: number;
    rewardPerAddress: string;
    showAdvancedSettings: boolean;
    atLeastLaptopQuery: boolean;
    userBitcoinReward: number;
    arr: number;
};

const ResultContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0px;

    width: 100%;

    @media ${mediaQueries.laptop} {
        position: initial;
        margin-right: 20px;
        padding-bottom: 0px;
        justify-content: space-between;
        z-index: 12;
    }
`;

const Title = styled.div`
    font-weight: 600;
    font-size: 16px;
    text-align: center;
`;

const Subtitle = styled.div`
    font-size: 14px;
    color: #222933;
    margin-bottom: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const MinSubtitle = styled(Subtitle)`
    margin-top: 0;
    margin-bottom: 12px;
`;

const SubtiTitleText = styled.div`
    margin-right: 5px;
`;

const ResultValue = styled.div`
    font-weight: 800;
    text-align: center;
    font-size: 26px;
    margin: 12px 0px;

    @media ${mediaQueries.laptop} {
        margin: 12px 0px;
    }

    ::after {
        opacity: 0;
        content: '';
    }

    ::before {
        opacity: 1;
        content: ${(props: { userBitcoinReward: number; userUSDReward: string; arr: number }) =>
            `'${props.userUSDReward} (${props.arr}%)'`};
    }

    ::before,
    ::after {
        transition: opacity 0.5s linear;
    }

    :hover::before {
        content: '';
        opacity: 0;
    }
    :hover::after {
        opacity: 1;
        content: ${(props: { userBitcoinReward: number; userUSDReward: string }) => `'${props.userBitcoinReward} BTC'`};
    }
`;

const MinResultValue = styled(ResultValue)`
    font-size: 16px;
`;

const Divider = styled.div`
    border: 1px solid #f0f0f5;
    margin: 32px -25px;

    @media ${mediaQueries.laptop} {
        position: initial;
        margin-right: 20px;
        padding-bottom: 0px;
        justify-content: space-between;
        margin: 32px -32px;
    }
`;

const MiminalViewResults = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    border: 1px solid #f0f0f5;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    box-shadow: 0px 1px 2px rgba(27, 39, 51, 0.04), 0px 4px 8px rgba(27, 39, 51, 0.04);
    z-index: 10;
`;

const MinResultContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const Result: React.FC<Props> = ({
    value,
    totalStxSupply,
    stackingThreshold,
    nrRewardsAddresses,
    nrUserRewardAddresses,
    rewardPerAddress,
    showAdvancedSettings,
    userBitcoinReward,
    arr,
}: Props) => {
    const [isResultVisible, setIsresultVisible] = useState(true);
    const [isStartStackingVisible, setIsStartStackingVisible] = useState(false);
    const history = useHistory();
    function onChange(isVisible: any) {
        setIsresultVisible(isVisible);
    }

    return (
        <Stat title="" marginTop="-100px">
            <ResultContainer>
                <Title>You could earn</Title>
                {isResultVisible && (
                    <React.Fragment>
                        <ResultValue userUSDReward={value} userBitcoinReward={userBitcoinReward} arr={arr} />
                        <Subtitle>
                            <SubtiTitleText> in Bitcoin per year</SubtiTitleText>
                        </Subtitle>
                    </React.Fragment>
                )}

                <VisibilitySensor onChange={onChange} offset={{ top: 50 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Link to={`/faq`}>
                            <Button width="100%">Get More Information</Button>
                        </Link>
                        <Button style={{ marginTop: '10px' }} onClick={() => setIsStartStackingVisible(true)}>
                            Start Stacking
                        </Button>
                    </div>
                </VisibilitySensor>
                {!isResultVisible && (
                    <MiminalViewResults>
                        <MinResultContainer>
                            <MinResultValue userUSDReward={value} userBitcoinReward={userBitcoinReward} arr={arr} />
                            <MinSubtitle>
                                <SubtiTitleText> in Bitcoin per year</SubtiTitleText>
                            </MinSubtitle>
                        </MinResultContainer>
                        <Button onClick={() => setIsStartStackingVisible(true)}>Get Started</Button>
                    </MiminalViewResults>
                )}
                <Divider></Divider>
                <Value
                    label="Liquid STX supply"
                    value={totalStxSupply}
                    tooltip="Total amount of liquid STX tokens supply available for stacking"
                ></Value>
                <Value
                    label="Stacking threshold"
                    value={stackingThreshold}
                    tooltip="Minimum amount of STX tokens required for stacking participation"
                ></Value>
                <CSSTransition in={showAdvancedSettings} classNames="example" timeout={600} unmountOnExit>
                    <div>
                        <Value
                            label="Amount of reward addresses"
                            value={nrRewardsAddresses}
                            tooltip="Total number of Bitcoin addresses which will receive stacking reward"
                        ></Value>
                        <Value
                            label="Your reward addresses"
                            value={nrUserRewardAddresses}
                            tooltip="Number of your Bitcoin addresses which will receive stacking reward"
                        ></Value>
                        <Value
                            label="Reward per address"
                            value={rewardPerAddress}
                            tooltip="Amount of Bitcoin in USD you will receive per address"
                        ></Value>
                    </div>
                </CSSTransition>

                <Route
                    path={`/faq`}
                    render={() => {
                        return (
                            <Modal isOpen={true} onClose={() => history.push('/')} title="FAQ">
                                <FAQ />
                            </Modal>
                        );
                    }}
                />
                <Modal
                    isOpen={isStartStackingVisible}
                    onClose={() => setIsStartStackingVisible(false)}
                    title="Stacking"
                >
                    <Stacking onSubmit={() => setIsStartStackingVisible(false)} />
                </Modal>
            </ResultContainer>
        </Stat>
    );
};

export default Result;
